module.exports = __webpack_public_path__ + "images/previous-month-arrow.png";